import {useEffect, useState} from 'react';
import {userService} from '@jobseeker/common-core/services';
import {CookieBannerWidget as Props} from '../components/CookieBanner/types';
import CookieBannerFeature from '@jobseeker/feature-navigation/components/CookieBanner';

const CookieBanner = (props: Props) => {
  const [loading, setLoading] = useState(false);

  const enableCookieBanner = async () => {
    const privacyPolicyAccepted = localStorage.getItem(
      'privacy-policy-accepted'
    );
    if (privacyPolicyAccepted && privacyPolicyAccepted === 'true') {
      sessionStorage.setItem('privacy-policy-viewed', 'true');
    }

    const privacyPolicyViewed = sessionStorage.getItem('privacy-policy-viewed');
    if (privacyPolicyViewed && privacyPolicyViewed === 'true') {
      props.setShowCookieBanner(false);
    } else {
      props.setShowCookieBanner(true);
      sessionStorage.setItem('privacy-policy-viewed', 'true');
    }
  };

  const saveCookiePolicyAcceptance = async () => {
    const cookiePolicyResponse = await userService.saveCookiePolicyAcceptance();
    if (cookiePolicyResponse?.id) {
      props.setShowCookieBanner(false);
      setLoading(false);
      localStorage.setItem('privacy-policy-accepted', 'true');
    }
  };

  useEffect(() => {
    enableCookieBanner();
  }, []);

  return (
    <CookieBannerFeature
      saveCookiePolicyAcceptance={saveCookiePolicyAcceptance}
      loading={loading}
      setLoading={setLoading}
      {...props}
    />
  );
};

export default CookieBanner;
